import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router';
import DailySpendDataGrid from 'components/reports/orders/DailySpendDataGrid';
import PriceBreakDownFilter from 'components/reports/products/priceBreakDown/PriceBreakDownFilter';
import { toast } from 'react-toastify';
import {
  convertQueryParamsIntoObject,
  convertObjectIntoQueryParams,
  dateFormat,
} from 'constant/Helpers';
// actions
import { setLoaderOpenTrue, setLoaderOpenFalse } from 'store/app/AppActions';
// api
import OrdersReportService from 'services/reportsService/OrdersReportService';
// datadog
import { errorLogger } from 'datadog/DDUtils';

const GiftsDailySpendReportPage = () => {
  const [dailySpendData, setDailySpendData] = useState([]);
  const [inputValues, setInputValues] = useState({
    fromDate: dateFormat(new Date()),
    toDate: dateFormat(new Date()),
  });
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const fetchData = async (params) => {
    dispatch(setLoaderOpenTrue());
    try {
      const res = await OrdersReportService.getDailySpendReport(params);
      setDailySpendData(res.data);
      dispatch(setLoaderOpenFalse());
    } catch (err) {
      errorLogger('Gifts Daily Spend Report Page Fetch Data Error:', err);
      dispatch(setLoaderOpenFalse());
      toast.error('Failed to get data!!');
    }
  };

  useEffect(() => {
    if (location.search) {
      const queryObj = convertQueryParamsIntoObject(location.search);
      fetchData(queryObj);
    } else {
      fetchData(inputValues);
    }
  }, []);

  const handleSubmit = async () => {
    const queryString = convertObjectIntoQueryParams(inputValues);
    navigate({
      pathname: '/report/DesignerOrderBreakDownReport',
      search: queryString,
    });
    fetchData(inputValues);
  };

  const handleExport = async () => {
    try {
      const res = await OrdersReportService.exportGetDailySpendReport(inputValues);
      toast.success(res?.data?.message);
    } catch (err) {
      errorLogger('Gifts Daily Spend Report Page Export Data Error:', err);
      toast.error('Failed to export excel file!!');
    }
  };

  return (
    <div className="toolbar-table-style">
      <PriceBreakDownFilter
        inputValues={inputValues}
        setInputValues={setInputValues}
        handleSubmit={handleSubmit}
        hasExport
        handleExport={handleExport}
        title="Gifts Daily Spend"
        defaultDate
      />
      <DailySpendDataGrid data={dailySpendData} />
    </div>
  );
};

export default GiftsDailySpendReportPage;
